import { render, staticRenderFns } from "./ClientOfferEmail.vue?vue&type=template&id=0ae5819b&"
import script from "./ClientOfferEmail.vue?vue&type=script&lang=js&"
export * from "./ClientOfferEmail.vue?vue&type=script&lang=js&"
import style0 from "./ClientOfferEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports